import { Link, Outlet } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import Icon from './Icon';
import { PLAY_STORE_URL } from '../lib/links';

/**
 * PublicLayout — restrained shared shell for public routes. Authentication
 * stays a real route, while legal and account-deletion links remain available
 * without turning the public navigation into a link directory.
 *
 * Protected routes under /app/* use AppShell (NavRail shell) instead.
 */
export default function PublicLayout() {
  return (
    <div className="flex min-h-[100dvh] flex-col bg-background text-on-surface">
      <header className="sticky top-0 z-30 border-b border-outline-variant/50 bg-background/90 backdrop-blur">
        <div className="mx-auto flex min-h-16 w-full max-w-max-width-content items-center justify-between gap-4 px-gutter py-2">
          <Link
            to="/"
            aria-label="Loaf home"
            className="inline-flex min-h-11 shrink-0 items-center gap-2 text-on-surface transition-colors hover:text-primary"
          >
            <BrandLogo size={32} withText textColor="text-on-surface" />
          </Link>
          <nav aria-label="Public navigation" className="flex items-center gap-1 font-label-lg text-label-lg text-on-surface-variant sm:gap-3">
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-11 items-center gap-1.5 rounded-md px-2 font-medium text-primary transition-colors hover:text-primary/80 sm:px-3"
            >
              <Icon name="android" className="text-[18px]" />
              <span className="hidden sm:inline">Get the app</span>
              <span className="sm:hidden">Get app</span>
            </a>
            <Link
              to="/privacy"
              className="hidden min-h-11 items-center rounded-md px-2 transition-colors hover:text-on-surface sm:inline-flex sm:px-3"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="hidden min-h-11 items-center rounded-md px-2 transition-colors hover:text-on-surface sm:inline-flex sm:px-3"
            >
              Terms
            </Link>
            <Link
              to="/auth"
              className="inline-flex min-h-11 items-center rounded-md px-2 font-medium text-on-surface transition-colors hover:text-primary sm:px-3"
            >
              Sign in
            </Link>
          </nav>
        </div>
      </header>

      <main className="min-w-0 flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-outline-variant/50 bg-surface">
        <div className="mx-auto flex w-full max-w-max-width-content flex-col gap-4 px-gutter py-8 font-label-sm text-label-sm text-on-surface-variant sm:flex-row sm:items-center sm:justify-between">
          <p>&copy; 2026 Binod Swain</p>
          <nav aria-label="Legal navigation" className="flex flex-wrap gap-x-5 gap-y-2">
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-11 items-center gap-1 transition-colors hover:text-primary"
            >
              <Icon name="android" className="text-[16px]" />
              Google Play
            </a>
            <Link to="/privacy" className="inline-flex min-h-11 items-center transition-colors hover:text-on-surface">
              Privacy
            </Link>
            <Link to="/terms" className="inline-flex min-h-11 items-center transition-colors hover:text-on-surface">
              Terms
            </Link>
            <Link to="/account/delete" className="inline-flex min-h-11 items-center transition-colors hover:text-on-surface">
              Delete account
            </Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
